<template>
  <div class="max-w-5xl mx-auto">
    <!-- 页面标题 -->
    <div class="text-center mb-12">
      <h1 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-800 mb-4">关于我们</h1>
      <p class="text-neutral-500 max-w-2xl mx-auto">EliteShop 成立于2015年，是一家专注于提供高品质商品和卓越购物体验的电商平台。</p>
    </div>
    
    <!-- 公司简介 -->
    <div class="bg-white rounded-lg shadow-md p-8 mb-12">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <i class="fa fa-building text-primary mr-3"></i>
        公司简介
      </h2>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div>
          <p class="mb-4 text-lg">EliteShop 致力于为消费者提供高品质、高性价比的商品和愉悦的购物体验。</p>
          <p class="mb-4">我们的使命是通过技术创新和优质服务，让购物变得简单、高效、愉悦。</p>
          <p class="mb-4">自成立以来，我们已服务超过1000万用户，合作品牌超过500个，覆盖电子产品、服装、家居、美妆等多个品类。</p>
          <p>我们始终坚持"客户第一、诚信经营、持续创新、追求卓越"的核心价值观，努力成为消费者最信赖的电商平台。</p>
        </div>
        <div>
          <img src="https://picsum.photos/800/500?random=1" alt="公司办公环境" class="rounded-lg shadow-lg w-full h-auto">
        </div>
      </div>
    </div>
    
    <!-- 我们的团队 -->
    <div id="team" class="bg-white rounded-lg shadow-md p-8 mb-12">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <i class="fa fa-users text-primary mr-3"></i>
        我们的团队
      </h2>
      
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <div class="text-center">
          <img src="https://picsum.photos/300/300?random=2" alt="团队成员" class="w-32 h-32 rounded-full mx-auto mb-4 object-cover">
          <h3 class="font-semibold text-lg mb-1">张明</h3>
          <p class="text-primary mb-2">创始人 & CEO</p>
          <p class="text-sm text-neutral-500">前阿里巴巴高级产品经理，拥有10年电商行业经验</p>
        </div>
        <div class="text-center">
          <img src="https://picsum.photos/300/300?random=3" alt="团队成员" class="w-32 h-32 rounded-full mx-auto mb-4 object-cover">
          <h3 class="font-semibold text-lg mb-1">李婷</h3>
          <p class="text-primary mb-2">联合创始人 & CTO</p>
          <p class="text-sm text-neutral-500">前腾讯技术专家，负责平台技术架构和研发管理</p>
        </div>
        <div class="text-center">
          <img src="https://picsum.photos/300/300?random=4" alt="团队成员" class="w-32 h-32 rounded-full mx-auto mb-4 object-cover">
          <h3 class="font-semibold text-lg mb-1">王强</h3>
          <p class="text-primary mb-2">运营总监</p>
          <p class="text-sm text-neutral-500">丰富的电商运营经验，负责平台整体运营策略</p>
        </div>
        <div class="text-center">
          <img src="https://picsum.photos/300/300?random=5" alt="团队成员" class="w-32 h-32 rounded-full mx-auto mb-4 object-cover">
          <h3 class="font-semibold text-lg mb-1">赵芳</h3>
          <p class="text-primary mb-2">客服总监</p>
          <p class="text-sm text-neutral-500">专注客户体验提升，建立完善的客户服务体系</p>
        </div>
      </div>
    </div>
    
    <!-- 发展历程 -->
    <div class="bg-white rounded-lg shadow-md p-8 mb-12">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <i class="fa fa-history text-primary mr-3"></i>
        发展历程
      </h2>
      
      <div class="relative border-l-2 border-primary/30 pl-8 ml-4 space-y-8">
        <div class="relative">
          <div class="absolute -left-10 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center">
            <i class="fa fa-flag"></i>
          </div>
          <h3 class="font-semibold text-lg">2015年</h3>
          <p>EliteShop 正式成立，初始团队仅8人，专注于电子产品销售</p>
        </div>
        
        <div class="relative">
          <div class="absolute -left-10 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center">
            <i class="fa fa-line-chart"></i>
          </div>
          <h3 class="font-semibold text-lg">2017年</h3>
          <p>平台用户突破100万，品类扩展至服装、家居等多个领域</p>
        </div>
        
        <div class="relative">
          <div class="absolute -left-10 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center">
            <i class="fa fa-building-o"></i>
          </div>
          <h3 class="font-semibold text-lg">2019年</h3>
          <p>成立上海、广州分公司，员工规模超过200人</p>
        </div>
        
        <div class="relative">
          <div class="absolute -left-10 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center">
            <i class="fa fa-trophy"></i>
          </div>
          <h3 class="font-semibold text-lg">2021年</h3>
          <p>荣获"最佳电商平台"、"消费者最信赖品牌"等多项大奖</p>
        </div>
        
        <div class="relative">
          <div class="absolute -left-10 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center">
            <i class="fa fa-globe"></i>
          </div>
          <h3 class="font-semibold text-lg">2023年</h3>
          <p>用户突破1000万，开始布局海外市场</p>
        </div>
      </div>
    </div>
    
    <!-- 加入我们 -->
    <div id="careers" class="bg-white rounded-lg shadow-md p-8 mb-12">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <i class="fa fa-user-plus text-primary mr-3"></i>
        加入我们
      </h2>
      
      <div class="text-center mb-8">
        <p class="text-lg mb-4">我们正在寻找优秀的人才加入我们的团队，共同创造更美好的购物体验</p>
        <button class="bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-lg transition-colors">
          查看招聘职位
        </button>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="p-6 border border-neutral-200 rounded-lg hover:border-primary transition-colors">
          <div class="text-primary text-3xl mb-4">
            <i class="fa fa-lightbulb-o"></i>
          </div>
          <h3 class="font-semibold text-lg mb-2">创新文化</h3>
          <p>鼓励创新思维，支持员工提出新想法、尝试新方法</p>
        </div>
        
        <div class="p-6 border border-neutral-200 rounded-lg hover:border-primary transition-colors">
          <div class="text-primary text-3xl mb-4">
            <i class="fa fa-graduation-cap"></i>
          </div>
          <h3 class="font-semibold text-lg mb-2">成长空间</h3>
          <p>完善的培训体系和晋升通道，助力员工职业发展</p>
        </div>
        
        <div class="p-6 border border-neutral-200 rounded-lg hover:border-primary transition-colors">
          <div class="text-primary text-3xl mb-4">
            <i class="fa fa-gift"></i>
          </div>
          <h3 class="font-semibold text-lg mb-2">福利待遇</h3>
          <p>五险一金、年终奖、带薪年假、节日福利、定期团建</p>
        </div>
      </div>
    </div>
    
    <!-- 联系我们 -->
    <div id="news" class="bg-white rounded-lg shadow-md p-8">
      <h2 class="text-2xl font-semibold mb-6 flex items-center">
        <i class="fa fa-newspaper-o text-primary mr-3"></i>
        新闻中心
      </h2>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="border-b border-neutral-200 pb-6">
          <div class="flex items-center mb-3">
            <span class="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full">2024-03-15</span>
            <span class="ml-3 text-sm text-neutral-500">公司动态</span>
          </div>
          <h3 class="font-semibold text-lg mb-2">EliteShop 完成B轮1亿美元融资，估值达10亿美元</h3>
          <p class="text-neutral-600 mb-4">本轮融资将主要用于技术研发、市场拓展和供应链建设...</p>
          <router-link to="#" class="text-primary hover:underline">阅读全文 <i class="fa fa-angle-right ml-1"></i></router-link>
        </div>
        
        <div class="border-b border-neutral-200 pb-6">
          <div class="flex items-center mb-3">
            <span class="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full">2024-02-20</span>
            <span class="ml-3 text-sm text-neutral-500">行业动态</span>
          </div>
          <h3 class="font-semibold text-lg mb-2">EliteShop 与10家知名品牌达成战略合作，丰富平台商品品类</h3>
          <p class="text-neutral-600 mb-4">此次合作将进一步提升平台商品丰富度，为消费者提供更多选择...</p>
          <router-link to="#" class="text-primary hover:underline">阅读全文 <i class="fa fa-angle-right ml-1"></i></router-link>
        </div>
        
        <div>
          <div class="flex items-center mb-3">
            <span class="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full">2024-01-10</span>
            <span class="ml-3 text-sm text-neutral-500">社会责任</span>
          </div>
          <h3 class="font-semibold text-lg mb-2">EliteShop 启动乡村振兴计划，助力农产品上行</h3>
          <p class="text-neutral-600 mb-4">计划将帮助100个乡村发展特色产业，带动农民增收致富...</p>
          <router-link to="#" class="text-primary hover:underline">阅读全文 <i class="fa fa-angle-right ml-1"></i></router-link>
        </div>
        
        <div>
          <div class="flex items-center mb-3">
            <span class="text-sm bg-primary/10 text-primary px-3 py-1 rounded-full">2023-12-25</span>
            <span class="ml-3 text-sm text-neutral-500">技术创新</span>
          </div>
          <h3 class="font-semibold text-lg mb-2">EliteShop 推出AI智能推荐系统，提升购物体验</h3>
          <p class="text-neutral-600 mb-4">新系统将根据用户行为和偏好，精准推荐商品，转化率提升30%...</p>
          <router-link to="#" class="text-primary hover:underline">阅读全文 <i class="fa fa-angle-right ml-1"></i></router-link>
        </div>
      </div>
      
      <div class="text-center mt-8">
        <router-link to="#" class="inline-block border border-primary text-primary hover:bg-primary hover:text-white px-6 py-2 rounded-lg transition-colors">
          查看更多新闻
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>